module.exports = __webpack_public_path__ + "img/cases-brand-avic-14.9fe60079.jpg";